import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import ICatAduanas from '../../../Interfaces/Catalogos/ICatAduanas'
const CatAduanas: ICatAduanas[] = [{id:0, Aduana: 'Aduana'}, {id:240, Aduana: 'Nuevo Laredo, Tamps.'}, {id:180, Aduana: 'Colombia, N.L.'}]
const initialState = { CatAduanas }

export const CatAduanasSlice = createSlice({
  name: 'CatAduanas',
  initialState: initialState,
  reducers: {
    resetCatAduanas : (state, action: PayloadAction<string>) => {
      state.CatAduanas =  []
    },  
    populateCatAduanas : (state, action: PayloadAction<ICatAduanas[]>) => {
        action.payload.forEach(element => {
            const index = state.CatAduanas.findIndex(object => object.id === element.id)
            if (index<0) state.CatAduanas.push(element)
        })
    },
    updateCatAduanas : (state, action: PayloadAction<ICatAduanas>) => {
      const i = state.CatAduanas.findIndex(_element => _element.id === action.payload.id);
      if (i > -1) state.CatAduanas[i] = action.payload;
      else state.CatAduanas.push(action.payload);
    },
    deleteCatAduanas : (state, action: PayloadAction<number>) => {
      const newArr = state.CatAduanas.filter(data => data.id != action.payload);
      state.CatAduanas=newArr
    },
  },
})

export const { resetCatAduanas, populateCatAduanas, updateCatAduanas, deleteCatAduanas } = CatAduanasSlice.actions;
export default CatAduanasSlice.reducer;